import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ============================================
// Fix: Patch DOM removeChild/insertBefore to prevent React crash
// when third-party scripts (Google Translate, analytics, etc.)
// modify the DOM outside React's control.
// See: https://github.com/facebook/react/issues/11538
// ============================================
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// Register PWA Service Worker with forced update
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Force check for update immediately
      reg.update();
      // Check for updates every 60 seconds
      setInterval(() => reg.update(), 60000);
    }).catch(() => {});
  });
}
